import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface UiState {
  notificationBadges: Record<string, string> // toolId -> badge message
  isLoadingGlobal: boolean
}

const initialState: UiState = {
  notificationBadges: {},
  isLoadingGlobal: false,
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setNotificationBadges(state, action: PayloadAction<Record<string, string>>) {
      state.notificationBadges = action.payload
    },
    setLoadingGlobal(state, action: PayloadAction<boolean>) {
      state.isLoadingGlobal = action.payload
    },
  },
})

export const { setNotificationBadges, setLoadingGlobal } = uiSlice.actions
export default uiSlice.reducer
